import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import {AppBar, Switch, Container} from '@mui/material'
import { useStyles } from './../App'
import { SocketContext } from '../contexts/socket';


interface Props {
  darkState: boolean
  handleThemeChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  username: string
}

export default function TopBar(props: Props) {
  const classes = useStyles();

  const toggleText = props.darkState? 'Toggle off for light mode': 'Toggle on for dark mode'

  return (
    <AppBar
      position="absolute"
      className={classes.appBar}
    >
      <Toolbar
        className={classes.toolbar}
      >
        <Container maxWidth="lg" sx={{ display: 'flex' }}>
          <Typography
            component="h1"
            variant="h6"
            // color="primary"
            noWrap
            className={classes.title}
          >
            {`Observers' Data Access Portal`}
          </Typography>
          <Tooltip title={toggleText}>
            <Switch checked={props.darkState} onChange={props.handleThemeChange} />
          </Tooltip>
        </Container>
      </Toolbar>
    </AppBar>
  )
}
